import React, { useContext } from 'react'
import { MyMobileContext } from './Context/MyMobileContext'

function FacebookPhoneScreen() {
  const {textAndfont,myFacebookDesignColor} = useContext(MyMobileContext)
  return (
    <>
    <div class="My-radio-main-phone-div">
        <p style={{margin:"0px 12px",height:"inherit",display:"Flex",color:myFacebookDesignColor,justifyContent:"center",alignItems:"center",fontSize:`${textAndfont}`}}>
            The preview is not available on the simulator. But don’t worry, the website will display fine on your mobile.</p>
        </div>
    </>
  )
}

export default FacebookPhoneScreen